import client from 'posthog-js';

import { isTruthy } from '@/utils/bool';
import { store } from '@/store';

import { SEPARATOR } from '@/constants';

const KEY = import.meta.env.VELA_POSTHOG_KEY;
const HOST = import.meta.env.VELA_POSTHOG_HOST;

export const posthog = {
  client,
  init() {
    if (!KEY || !HOST) return;

    this.client.init(KEY, { api_host: HOST, autocapture: false, capture_pageview: 'history_change' });
    this.initialized = true;
  },
  /**
   * Reset distinct_id to a fresh anonymous ID. Call on logout so the next
   * user (or new signup) is not merged with the previous user in PostHog.
   */
  reset() {
    if (!this.initialized) return;

    this.client.reset();
    this.identified = false;
  },
  setUser(user) {
    if (!this.initialized) return;

    if (this.identified) {
      this.client.reset();
    }

    if (!user) {
      this.identified = false;
      return;
    }

    const firstName = (user.firstName || '');
    const lastName = user.lastName || '';
    const name = [firstName, lastName].filter(isTruthy).join(SEPARATOR.SPACE);

    // Identify with email as primary distinct_id first
    this.client.identify(user.email, {
      vela_user_id: user.userId,
      email: user.email,
      name,
    });

    // Merge any existing userId-based person into email (handles legacy FE identify(userId) + BE identify(email) split)
    this.client.capture('$merge_dangerously', { alias: user.userId });

    this.identified = true;
  },
  track({ event, shopId, ...rest }) {
    if (!this.initialized) return;

    const properties = rest;

    if (shopId) {
      const state = store.getState();
      const shop = state.getIn(['shops', 'byId', shopId]);

      if (shop) {
        properties.channel = shop.get('channel');
        properties.shop_name = shop.get('name');
        properties.vela_db = shop.get('db');
        properties.vela_shop_id = shopId;

        const subscription = state.getIn(['user', 'subscriptions', shopId]);

        if (subscription) {
          const [plan, tier] = subscription.get('plan')?.split(SEPARATOR.DOT) || [];
          properties.plan = plan || 'none';

          if (tier) {
            properties.tier = tier.replace(/^tier_/, '');
          } else {
            properties.tier = 'none';
          }
        }
      }
    }

    this.client.capture(event, properties);
  },
};
